import { ApplicationConfig, isDevMode, ErrorHandler, provideAppInitializer, inject } from '@angular/core';
import { provideRouter, withPreloading, PreloadAllModules, RouteReuseStrategy } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { IonicRouteStrategy, provideIonicAngular } from '@ionic/angular/standalone';
import { GlobalErrorHandler } from './services/global-error-handler';
import { apiUrlInterceptorFn } from './interceptors/api-url.interceptor';
import { apiKeyInterceptorFn } from './interceptors/api-key.interceptor';
import { http429InterceptorFn } from './interceptors/http-429.interceptor';
import { billingUpgradeInterceptorFn } from './interceptors/billing-upgrade.interceptor';
import { provideTransloco } from '@jsverse/transloco';
import { HttpLoader } from './services/language.service';
import { routes } from './app.routes';
import { TraceService } from '@sentry/angular';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes, withPreloading(PreloadAllModules)),
    provideIonicAngular(),
    provideHttpClient(withInterceptors([
      apiUrlInterceptorFn,
      apiKeyInterceptorFn,
      http429InterceptorFn,
      billingUpgradeInterceptorFn,
    ])),
    provideTransloco({
      config: {
        availableLangs: ['en', 'fr', 'es', 'ar'],
        defaultLang: 'en',
        reRenderOnLangChange: true,
        prodMode: !isDevMode(),
      },
      loader: HttpLoader,
    }),
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    // Initialize Sentry TraceService to enable performance monitoring for routing & HTTP calls
    provideAppInitializer(() => {
      inject(TraceService);
    }),
  ]
};
